import script from "./SettlementProcess.vue?vue&type=script&setup=true&lang=js"
export * from "./SettlementProcess.vue?vue&type=script&setup=true&lang=js"

import "./SettlementProcess.vue?vue&type=style&index=0&id=114e5b98&lang=less&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-114e5b98"]])

export default __exports__